/**
 * Layout component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */

import React from "react";
import PropTypes from "prop-types";
import { StaticQuery, graphql } from "gatsby";
// import { Link } from "gatsby"

import Header from "./header";
import "../main.css";
import "../app.css";

const Layout = ({ children }) => (
  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
          }
        }
      }
    `}
    render={data => (
      <>
        <Header siteTitle={data.site.siteMetadata.title} />
        <div>
          <main>{children}</main>
        </div>

        <footer>
          <div
            className="container-fluid pb-2 pt-3 mt-3 "
            style={{ backgroundColor: "#929292" }}
          >
            <div className="container d-flex flex-column flex-sm-row">
              <p
                className="ml-auto pr-5 ml-sm-0 pl-5 order-3 order-sm-1"
                style={{
                  color: "white"
                }}
              >
                Copyright {new Date().getFullYear()} Sturminster UK Ltd
              </p>
              <p className="ml-auto pr-5 text-white order-1 order-sm-3">
                Email:{" "}
                <a
                  href="mailto:mail@sturminster.co.uk"
                  style={{
                    // textDecoration: "none",
                    color: "white"
                  }}
                >
                  mail@sturminster.co.uk{" "}
                </a>
                <br />
                Tel: 01202 022487
              </p>
            </div>
          </div>
        </footer>
      </>
    )}
  />
);

Layout.propTypes = {
  children: PropTypes.node.isRequired
};

export default Layout;
